import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import TirPlanView from "../components/TirPlanView";
import { BarTitle } from "../components/CollapseBar";
import { Button } from "../components/ui/button";
import { Boxes, Plus } from "lucide-react";

export default function TirPlan() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const ro = sp.get("ro") === "1";
  const nav = useNavigate();
  const [tirs, setTirs] = useState([]);
  const [plan, setPlan] = useState(null);
  const [users, setUsers] = useState([]);
  const [mine, setMine] = useState([]);
  useEffect(() => { if (ro) api.get("/driver/pickups", { silent: true }).then((r) => setMine(r.data)).catch(() => {}); }, [ro]);

  useEffect(() => {
    api.get(ro ? "/driver/tirs" : "/tirs").then((r) => { setTirs(r.data); if (!id && r.data[0]) nav(`/tir-plan/${r.data[0].id}${ro ? "?ro=1" : ""}`, { replace: true }); });
    if (!ro) api.get("/users", { silent: true }).then((r) => setUsers(r.data)).catch(() => {});
  }, [id, ro, nav]);

  const load = useCallback(async (force) => {
    if (!id) return;
    const r = force ? await api.post(`/tirs/${id}/pack`) : await api.get(`/tirs/${id}/plan`);
    setPlan(r.data);
  }, [id]);
  useEffect(() => { setPlan(null); load(false); }, [load]);

  const overflow = async () => { const r = await api.post(`/tirs/${id}/overflow`); toast.success(`YENİ TIR AÇILDI: ${r.data.new_tir}`); nav(`/tir-plan/${r.data.new_tir}`); };
  const newTir = async () => {
    const t = plan?.tir || {};
    const r = await api.post("/tirs", { plate: "", driver: "", yon: t.yon || "", hatlar: t.hatlar || [], yerlesim: "TABAN", arac: t.arac || "TIR", strateji: t.strateji || "OTOMATIK" });
    toast.success("YENİ TIR EKLENDİ"); nav(`/tir-plan/${r.data.id}`);
  };

  return (
    <div className="mw-fade-up space-y-3" data-testid="tir-plan-page">
      <BarTitle><div>
        <h1 className="font-head flex items-center gap-2 text-3xl font-bold tracking-tight text-white"><Boxes className="h-7 w-7 text-amber-400" /> TIR YÜKLEME (3D)</h1>
        <p className="text-sm text-slate-400">{tirs.length} TIR</p>
      </div></BarTitle>
      <div className="flex flex-wrap items-center gap-1">
        {tirs.map((t) => (
          <button key={t.id} data-testid={`plan-tab-${t.id}`} onClick={() => nav(`/tir-plan/${t.id}${ro ? "?ro=1" : ""}`)}
            className={`rounded-md border px-3 py-1 text-xs font-semibold ${t.id === id ? "border-amber-500 bg-amber-500/15 text-amber-300" : "border-slate-700 bg-slate-800 text-slate-300 hover:bg-slate-700"}`}>
            {t.plate || t.id} {t.yon ? `· ${t.yon}` : ""}{t.closed ? " (KAPALI)" : ""}{t.sorunlar?.length ? ` ⚠ SORUNLU (${t.sorunlar.length})` : ""}
          </button>
        ))}
        {!ro && <Button data-testid="plan-new-tir" size="sm" onClick={newTir} className="h-7 bg-blue-600 text-white hover:bg-blue-700"><Plus className="mr-1 h-3.5 w-3.5" /> TIR EKLE</Button>}
      </div>
      {!id && tirs.length === 0 && <div className="rounded-xl border border-slate-800 bg-slate-900 px-4 py-16 text-center text-slate-500">HENÜZ TIR YOK. "TIR EKLE" İLE AÇIN, KARGO ALIMI'NDA ALIMLARI TIRA ATAYIN.</div>}
      {ro && (
        <div data-testid="driver-pickups" className="rounded-lg border border-emerald-800 bg-emerald-950/20 p-2 text-xs text-slate-200">
          <div className="mb-1 font-bold text-emerald-300">ALIMLARIM ({mine.length})</div>
          {mine.map((p) => { const d = p.data || {}; return <div key={p.id} data-testid={`driver-pickup-${p.id}`} className="flex flex-wrap gap-2 border-t border-emerald-900/50 py-0.5"><b>{d.gonderici_firma}</b><span>{d.gonderen_ilce} {d.gonderen_il}</span><span>{d.gonderen_tel}</span><span>→ {d.alici_il}</span><span>{d.adet} {d.kargo_turu} · {d.kg || 0} KG · {d.desi || 0} DESİ</span><span className="text-amber-300">{d.alim_durumu}</span>{p.tir_id && <span className="text-sky-300">TIR {p.tir_id}</span>}</div>; })}
          {!mine.length && <div className="text-slate-500">SİZE ATANMIŞ ALIM YOK</div>}
        </div>
      )}
      {plan && <TirPlanView plan={plan} readOnly={ro} users={users} tirs={tirs} onReload={load} onOverflow={overflow} />}
    </div>
  );
}
